export enum SupportedChainId {
  NAHMII_MAINNET = 5551,
  NAHMII_TESTNET = 5553,
}
